import { render, staticRenderFns } from "./DetailsCourseWordItem.vue?vue&type=template&id=9741b7a2&scoped=true&"
import script from "./DetailsCourseWordItem.vue?vue&type=script&lang=js&"
export * from "./DetailsCourseWordItem.vue?vue&type=script&lang=js&"
import style0 from "./DetailsCourseWordItem.vue?vue&type=style&index=0&id=9741b7a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9741b7a2",
  null
  
)

export default component.exports